(ns nosco.richtext.merge-tags
  (:require
   ["prosemirror-state" :as prosemirror-state]
   [nosco.i18n.translate :as t]
   [cljs-bean.core :as bean]))

(defn merge-tag->text [mt]
  (case mt
    "%recipient.fname%" (t/t "First name")
    "%recipient.lname%" (t/t "Last name")
    "%recipient.email%" (t/t "Email")
    "%recipient.resetLink%" (t/t "Reset password link")
    "%recipient.activationLink%" (t/t "Account activation link")))

(defn- merge-tag-view
  "A NodeViewConstructor returning a NodeView for rendering merge-tags

  https://prosemirror.net/docs/ref/#view.NodeViewConstructor
  https://prosemirror.net/docs/ref/#view.NodeView"
  [^js node view get-position-fn]
  (let [attrs (bean/bean (.-attrs node))
        merge-tag (:merge-tag attrs)
        dom (doto (.createElement js/document "span")
              (.setAttribute "data-merge-tag" merge-tag))
        _ (set! (.-innerText dom) (merge-tag->text merge-tag))]
    #js {:dom dom}))

(defonce merge-tags-plugin-key (prosemirror-state/PluginKey. "nosco-merge-tags"))

(defn merge-tags-plugin
  "Returns a plugin which adds controls to the figure node type."
  []
  (prosemirror-state/Plugin.
   #js {:key merge-tags-plugin-key
        :props #js {:nodeViews #js {:merge_tag merge-tag-view}}}))
